<template>
    <b-dropdown-group>
        <b-dropdown-header
            @click="visible = !visible"  
            class="cursor-pointer"
        >
            <slot name="header" />
            <i 
                class="fa pull-right mt-1"
                :class="visible ? 'fa-angle-down' : 'fa-angle-left'"
            />
        </b-dropdown-header>
        <template v-if="visible">
            <slot name="items" />
        </template>
    </b-dropdown-group>
</template>
<script>
export default {
    data() {
        return {
            visible: false
        };
    },
}
</script>